// Copyright 2020-2025 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: GPL-3.0

export enum DirectiveName {
  DerivedFrom = 'derivedFrom',
  Entity = 'entity',
  JsonField = 'jsonField',
  FullText = 'fullText',
}
